import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { ErrorData } from '@types';

type Loading = 'update-user-state';

export type UserStatus = {
  error: ErrorData | null;
  loading: Loading[];
  showSuccessDialog: boolean;
};

type UserStatusStateReducer<P = void> = (
  state: UserStatus,
  action: PayloadAction<P>
) => void;

const initialState: UserStatus = {
  error: null,
  loading: [],
  showSuccessDialog: false,
};

const handleFailure: UserStatusStateReducer<ErrorData> = (state, action) => {
  state.error = action.payload;
};

const handleUpdateUserStatus: UserStatusStateReducer<{
  userId: number;
  status: 'ACTIVE';
}> = state => {
  state.loading.push('update-user-state');
  state.error = null;
};

const handleUpdateUserStatusSuccess: UserStatusStateReducer = state => {
  state.error = null;
  state.showSuccessDialog = true;
};

const handleUpdateUserStatusFulfill: UserStatusStateReducer = state => {
  state.loading = state.loading.filter(l => l !== 'update-user-state');
};

const UserStatus = createSlice({
  name: 'UserStatus',
  initialState,
  reducers: {
    updateUserStatus: handleUpdateUserStatus,
    updateUserStatusSuccess: handleUpdateUserStatusSuccess,
    updateUserStatusFailure: handleFailure,
    updateUserStatusFulfill: handleUpdateUserStatusFulfill,
    toggleShowSuccessDialog: (state, action: PayloadAction<boolean>) => {
      state.showSuccessDialog = action.payload;
    },
  },
});

const { actions, reducer } = UserStatus;

export const {
  updateUserStatus,
  updateUserStatusSuccess,
  updateUserStatusFailure,
  updateUserStatusFulfill,
  toggleShowSuccessDialog,
} = actions;

export default reducer;
